import React, { useState, useEffect } from "react";
import { Form, Typography, Input, Space, Button, Radio, Switch } from "antd";

import { SaveOutlined, UndoOutlined } from "@ant-design/icons";

//Importaciones para el uso de Redux
import { useDispatch } from "react-redux";
import { updateRolEnviromentAction } from "../../../../../actions/rolEnviromentActions";

//Styles
import curStyle from "../../../../../css/GlobalCmp.module.css";

//Importaciones Propias
import CST from "../../../../../utils/CustomSettings";
import { showNotification } from "../../../../../utils/ShowNotification";
import ERP from "../../../../../utils/ErpService";

export default function PrvConceptosNotasForm(props) {
  const { record, closeModal, currentUser, varEffec } = props;
  const [form] = Form.useForm();
  const [curId, setCurId] = useState(record.cnc_id);
  const [loadingButton, setLoadingButton] = useState(false);
  const [activo, setActivo] = useState(record.cnc_id > 0 ? record.cnc_activo : 0);
  const [cncTipo, setCncTipo] = useState(record.cnc_id > 0 ? record.cnc_tipo : "");

  useEffect(() => {
    setCurId(record.cnc_id);
  }, [varEffec]);

  //Ejecutar dispatch tras el logueo
  const dispatch = useDispatch();
  const updateEnviroment = (state) =>
    dispatch(updateRolEnviromentAction(state));

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 20 },
  };

  const { Title } = Typography;

  const guardarCambios = async (values) => {
    console.log(values);
    setLoadingButton(true);
    let val_record = await ERP.sendPrvConceptosNotas(
      currentUser,
      curId,
      activo,
      cncTipo,
      "PrvConceptosNotas",
      values
    );
    console.log(val_record);
    if (Number.parseInt(val_record.type) > 0) {
      updateEnviroment(val_record.datos.rol_entorno);
      showNotification(
        "topRight",
        4,
        "GESTION DE CONCEPTOS DE NOTAS DB/CD",
        "REGISTRO EXITOSO"
      );
    } else {
      showNotification(
        "topRight",
        2,
        "GESTION DE CONCEPTOS DE NOTAS DB/CD",
        val_record.message
      );
    }
    setLoadingButton(false);
    closeModal();
  };

  //Renderizacion del componente
  return (
    <Form
      {...layout}
      form={form}
      name="PrvConceptosNotas"
      onFinish={guardarCambios}
      initialValues={{
        cnc_nombre: record.cnc_id > 0 ? record.cnc_nombre : "",
        cnc_tipo: record.cnc_id > 0 ? record.cnc_tipo : "",
        cnc_activo: record.cnc_id > 0 ? record.cnc_activo : 0,
      }}
      scrollToFirstError
    >
      <Form.Item>
        <Title
          level={4}
          style={{
            padding: 2,
            margin: 2,
            fontWeight: 600,
            textAlign: "left",
            color: CST.colorSec,
          }}
        >
          {record.cnc_id > 0
            ? "ACTUALIZAR CONCEPTOS DE NOTAS DB/CD"
            : "AGREGAR CONCEPTOS DE NOTAS DB/CD"}
        </Title>
      </Form.Item>
      <Form.Item
        name="cnc_nombre"
        label="Nombre"
        rules={[
          {
            required: true,
            message: "El nombre es obligatorio",
          },
        ]}
      >
        <Input
          style={{ textTransform: "uppercase" }}
          value={record.cnc_id > 0 ? record.cnc_nombre : ""}
        />
      </Form.Item>
      <Form.Item
        name="cnc_tipo"
        label="Naturaleza"
        rules={[
          {
            required: true,
            message: "La Naturaleza es obligatoria",
          },
        ]}
      >
        <Radio.Group
          onChange={(option) => setCncTipo(option.target.value)}
          value={cncTipo}
        >
          <Radio value={1}>Debito</Radio>
          <Radio value={2}>Credito</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item
        name="cnc_activo"
        label="Activo"
        wrapperCol={{ span: 10 }}
        style={{ display: "flex", flexDirection: "row" }}
      >
        <Space direction="horizontal">
        <Switch
            checked={activo}
            onChange={(val) => setActivo(val ? 1 : 0)}
            checkedChildren="SI"
            unCheckedChildren="NO"
            defaultChecked
          />
        </Space>
      </Form.Item>
      <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 4 }}>
        <Space>
          <Button
            type="primary"
            htmlType="submit"
            className={curStyle.btnOrange}
            loading={loadingButton}
          >
            <SaveOutlined /> Guardar
          </Button>
          <Button
            type="primary"
            className={curStyle.btnInverse}
            onClick={() => closeModal()}
          >
            <UndoOutlined /> Cancelar
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
}
